import { config } from "@/data/config";
import { isModuleEnabled } from "@/lib/modules";

export type MobileAppDistribution = {
	iosAppStoreUrl?: string;
	googlePlayUrl?: string;
	/** Documented for native OAuth; backend uses GOOGLE_/GITHUB_MOBILE_CALLBACK_URL. */
	deepLinkScheme?: string;
};

/** Whether `modules.yaml` has native app distribution enabled. */
export function isMobileAppEnabled(): boolean {
	return isModuleEnabled("mobile_app");
}

/** Store links and deep-link hints from `config.mobileApp` (web). */
export function getMobileAppDistribution(): MobileAppDistribution | null {
	if (!isMobileAppEnabled()) {
		return null;
	}
	const { iosAppStoreUrl, googlePlayUrl, deepLinkScheme } =
		config.mobileApp ?? {};
	if (!iosAppStoreUrl && !googlePlayUrl && !deepLinkScheme) {
		return null;
	}
	return { iosAppStoreUrl, googlePlayUrl, deepLinkScheme };
}

export function hasMobileAppStoreLinks(
	distribution: MobileAppDistribution | null = getMobileAppDistribution(),
): distribution is MobileAppDistribution {
	return Boolean(distribution?.iosAppStoreUrl || distribution?.googlePlayUrl);
}
